<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Domain</th>
          <th>Status</th>
          <th>Expires</th>
          <th>Tags</th>
          <th>Links</th>
          <th>Completed</th>
          <th>Builder</th>
          <th style="width: 20%">
            <div class="col-lg-2"><i class="fas fa-hammer" v-tooltip="'Built'"></i></div>
            <div class="col-lg-2"><i class="fa fa-file" v-tooltip="'Content Added'"></i></div>
            <div class="col-lg-2"><i class="fa fa-check" v-tooltip="'QA'"></i></div>
            <div class="col-lg-2"><i class="fa fa-arrow-right" v-tooltip="'Site Moved'"></i></div>
            <div class="col-lg-2"><i class="fas fa-people-arrows" v-tooltip="'Domain Moved'"></i></div>
            <div class="col-lg-2"><i class="fa fa-check" v-tooltip="'Delivered'"></i></div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="site in sites" :key="site.id">
          <td>
            <pbn :pbn="site"></pbn>
          </td>
          <td>{{ site.status }}</td>
          <td>
            <i class="fa fa-warning" v-if="site.expiresIn < 1 && site.expiresIn > -90" style="color: red;" title="Expired!"></i>
            <span
              :class="!site.expiresIn || site.expiresIn > 30 ? 'green' : (site.expiresIn > 7 ? 'orange' : 'red')"
              :title="site.expires ? $moment(site.expires.date).format('DD.MM.YYYY') : '?'"
              v-if="site.expiresIn > -90"
            >
              {{ site.expiresIn || '?' }}
            </span>
            <span v-else style="color: orange;">?</span>
          </td>
          <td>
            <div v-for="(tag, i) in site.tags" :key="tag + site.id" class="label label-primary m-r-xs" :title="tag" v-if="i < 2">{{ shorten(tag, 5) }}</div>
            <div v-if="site.tags.length > 2" class="label label-primary m-r-n" :title="site.tags.join(',')">+{{ site.tags.length - 2 }}</div>
          </td>
          <td>
            <div v-if="site.linkTags && tag !== 'authority'" v-for="tag in site.linkTags" :key="tag" class="label label-primary m-r-xs" :title="tag">{{ shorten(tag, 5) }}</div>
          </td>
          <td>{{ site.buildActions['site-moved'] && site.buildActions['site-moved'].endTime ? $moment(site.buildActions['site-moved'].endTime.date).format('DD.MM.YY') : '' }}</td>
          <td>{{ site.buildActions['built'] && site.buildActions['built'].assignee ? site.buildActions['built'].assignee.name : '?' }}</td>
          <td>
            <div v-if="site.buildActions.built">
            <div :class="'col-lg-2 ' + getClass(site.buildActions.status)">
              <action :action="site.buildActions.built"></action>
            </div>
            <div class="col-lg-2">
              <action :action="site.buildActions.content"></action>
            </div>
            <div class="col-lg-2">
              <action :action="site.buildActions.qa"></action>
            </div>
            <div class="col-lg-2">
              <action :action="site.buildActions['site-moved']"></action>
            </div>
            <div class="col-lg-2">
              <action :action="site.buildActions['domain-moved']"></action>
            </div>
            <div class="col-lg-2">
              <action :action="site.buildActions.delivered"></action>
            </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <h4>Backorders</h4>
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Domain</th>
          <th>Added</th>
          <th>Cutoff (UTC)</th>
          <th>Status</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(back, i) in order.backorders" :key="'backs-' + i">
          <td>{{ back.domain }}</td>
          <td>{{ back.added | aTime('DD.MM.YYYY HH:mm') }}</td>
          <td>{{ back.cutoffTime ? $moment(back.cutoffTime.date).format('DD.MM.YYYY HH:mm') : '/' }}</td>
          <td :class="back.status === 'Success' ? 'green' : (back.status === 'Failed' ? 'red' : 'orange')">{{ back.status }}</td>
          <td>
            <span v-if="back.status === 'Active'">
              <a @click="deleteBackorder(back.id)"><i class="fa fa-trash" title="Delete"></i></a>
            </span>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Values } from '../../../../mixins/helperMixin'
import Action from '../Build/List/Actions'
import { mapGetters } from 'vuex'
import { ORDER_SET } from '../../../../store/mutation-types'
import PbnListItem from '../PbnListItem'

export default {
  data () {
    return {
      sites: [],
      meta: {}
    }
  },
  mounted () {
    this.getSites()
  },
  components: {
    action: Action,
    pbn: PbnListItem
  },
  computed: {
    ...mapGetters({
      order: 'getOrder'
    })
  },
  mixins: [Values],
  methods: {
    getSites () {
      axios.get('/pbn/list?orders=' + this.$route.params.orderId)
        .then(r => {
          this.sites = r.data.data
          this.meta = r.data.meta
        })
        .catch(e => {})
    },
    getClass (status) {
      return status === 'waiting' ? 'red' : status === 'started' ? 'yellow' : 'green'
    },
    deleteBackorder (id) {
      axios.delete('/pbn/backorder/' + id)
        .then(r => {
          this.$store.commit(ORDER_SET, r.data.order)
          this.$toastr.success('Order deleted!')
        }).catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Order/SiteList.vue